import {createFileRoute, Outlet, redirect, useLocation} from '@tanstack/react-router';
import {MONTHLY_ACTIVITY} from '@/practitioner/routing/paths';
import {
  grantUser,
  qualifiedPractitionerGranted
} from '@/practitioner/routing/utils/beforeLoadUtils';
import MonthlyActivity from '@/practitioner/views/activity/MonthlyActivity';
import {AppRouterContext} from '@/shared/routing';
import {USER_HOME} from '@/shared/routing/paths';

function ActivityLayout() {
  const {pathname} = useLocation();
  const isRoot = pathname === MONTHLY_ACTIVITY;
  return isRoot ? <MonthlyActivity /> : <Outlet />;
}

export const Route = createFileRoute('/(practitioner)/practitioner/activity')({
  component: ActivityLayout,
  beforeLoad: function ({context}: {context: AppRouterContext}) {
    if (context.company?.isForClinicalTrials) {
      throw redirect({to: USER_HOME, replace: true});
    }
    grantUser(qualifiedPractitionerGranted)({context, location: {pathname: MONTHLY_ACTIVITY}});
  }
});
